import { Dropdown } from "capitalrx-components-2.0/lib/forms";
import { FC, ReactNode } from "react";

export interface TextboxDropdownProps {
  readonly label: ReactNode;
  readonly options: string[];
  readonly selectedOption: string;
  readonly onOptionSelected?: (option: string) => void;
}

export const TextboxDropdown: FC<TextboxDropdownProps> = (props: TextboxDropdownProps) => {
  const { label, options, selectedOption, onOptionSelected } = props;

  const handleChange = (selected: string | number) => {
    if (typeof selected === "number") {
      onOptionSelected(selected.toString());
    } else {
      onOptionSelected(selected);
    }
  };

  return (
    <Dropdown value={selectedOption} label={label} onChange={handleChange}>
      {options?.map((item) => {
        return (
          <Dropdown.Option key={item} value={item}>
            {item}
          </Dropdown.Option>
        );
      })}
    </Dropdown>
  );
};
